import JustValidate from 'just-validate';
import Inputmask from "../../../../node_modules/inputmask/dist/inputmask.es6.js";
import intlTelInput from 'intl-tel-input';
import * as utils from "../../../../node_modules/intl-tel-input/build/js/utils.js";
import * as countryList from "countries-phone-masks";
import JustValidatePluginDate from 'just-validate-plugin-date';
import moment from 'moment';

export default function validateForms (selector, rules, checkboxes = [], afterSend) {
  const form = document?.querySelector(selector);
  const telSelector = form?.querySelector('input[type="tel"]');
  const timeSelector = form?.querySelector('input[type="time"]');
  const dateSelector = form?.querySelector('input[type="date"]');
  const url = form?.action;

  if (!form) {
    console.error('Нет такого селектора!');
    return false;
  }

  if (!rules) {
    console.error('Вы не передали правила валидации!');
    return false;
  }

  if (telSelector) {
    const telInput = intlTelInput(telSelector, {
      utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.3.2/build/js/utils.js",
      separateDialCode: true,
      hiddenInput: function(telInputName) {
        return {
          phone: "phone_full",
        };
      },
      initialCountry: 'vn',
      autoPlaceholder: 'off',
      formatAsYouType: false,
    })

    function getCodeMask(selector) {
      let country = selector.getSelectedCountryData();
      let countryData = countryList.find(({ iso }) => iso === country.iso2.toUpperCase());
      let countryMask = countryData.mask
      let maskValue;

      if(Array.isArray(countryMask)) {
        maskValue = countryMask[0]
      } else {
        maskValue = countryMask
      }

      const inputMask = new Inputmask(maskValue.replace(/#/g, '9').toString());
      inputMask.mask(telSelector);
    }

    getCodeMask(telInput);

    telSelector.addEventListener("countrychange", function(e) {
      getCodeMask(telInput);
    });

    for (let item of rules) {
      if (item.tel) {
        item.rules.push({
          rule: 'function',
          validator: function() {
            const phone = telSelector.inputmask.unmaskedvalue();
            return phone.length >= 4;
          },
          errorMessage: item.telError
        });
      }
    }
  }

  if(timeSelector) {
    for (let item of rules) {
      if (item.time) {
        const start = moment(new Date().toDateString() + ' 16:00').format('X');
        const end =  moment(new Date().toDateString() + ' 23:59').format('X');

        item.rules.push({
          rule: 'function',
          validator: function() {
            const currentTime = moment(new Date().toDateString() + ' ' + timeSelector.value).format('X');
            return currentTime >= start && currentTime < end;
          },
          errorMessage: item.timeError
        });
      }
    }
  }

  if(dateSelector) {
    for (let item of rules) {
      if (item.date) {
        const today = moment(new Date().toDateString()).format('X');

        item.rules.push({
          rule: 'function',
          validator: function() {
            const currentDate = moment(dateSelector.value).format('X');
            return currentDate >= today;
          },
          errorMessage: item.dateError
        });
      }
    }
  }

  const validation = new JustValidate(selector);

  for (let item of rules) {
    validation
      .addField(item.ruleSelector, item.rules);
  }

  if (checkboxes.length) {
    for (let item of checkboxes) {
      validation
        .addRequiredGroup(
          `${item.selector}`,
          `${item.errorMessage}`
        )
    }
  }

  validation.onSuccess((ev) => {
    let formData = new FormData(ev.target);

    let xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {

        }
      }
    }

    xhr.open('POST', url, true);
    xhr.send(formData);
    if (afterSend) {
      afterSend(form);
    }

    ev.target.reset();
  })

};
